module.exports = __webpack_public_path__ + "media/src/assets/images/close-3338e53b501cbdc001ef59c0ce7d7a3c.svg";